import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postFeedAdViewById,
  type PostFeedAdViewByIdParams,
  type PostFeedAdViewByIdResponse,
} from '@services/FeedAdService';

export type UsePostFeedAdViewByIdParams = PostFeedAdViewByIdParams & {
  mutationOptions?: SWRMutationConfiguration<
    PostFeedAdViewByIdResponse,
    unknown,
    string,
    never,
    PostFeedAdViewByIdResponse
  >;
};

export const postFeedAdViewByIdMutationKey = (id: number) =>
  `post-feed-ad-view-by-id-${id}`;

export const usePostFeedAdViewById = ({
  id,
  mutationOptions,
}: UsePostFeedAdViewByIdParams) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostFeedAdViewByIdResponse,
    unknown,
    string,
    never
  >(
    postFeedAdViewByIdMutationKey(id),
    () => postFeedAdViewById({ id }),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
